import { render, staticRenderFns } from "./AnomalyChart.vue?vue&type=template&id=b04506ae&scoped=true&"
import script from "./AnomalyChart.vue?vue&type=script&lang=js&"
export * from "./AnomalyChart.vue?vue&type=script&lang=js&"
import style0 from "./AnomalyChart.vue?vue&type=style&index=0&id=b04506ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04506ae",
  null
  
)

export default component.exports